module.exports = __webpack_public_path__ + "img/36.e5ed1e58.jpg";